import addressService from '../services/address'

// state
export const state = {
  addresses: [],
  addressesLoading: false,
  addressesError: null
}

// getters
export const getters = {
  addresses: state => state.addresses,
  addressesLoading: state => state.addressesLoading,
  addressesError: state => state.addressesError
}

// mutations
export const mutations = {
  SET_ADDRESSES(state, addresses) {
    state.addresses = addresses
  },
  SET_ADDRESSES_LOADING(state, loading) {
    state.addressesLoading = loading
  },
  SET_ADDRESSES_ERROR(state, error) {
    state.addressesError = error
  }
}

// actions
export const actions = {
  async fetchAddresses({ commit }, params) {
    try {
      commit('SET_ADDRESSES_LOADING', true)
      const { data } = await addressService.fetchAddresses(params)
      return data.data
    } catch (error) {
      commit('SET_ADDRESSES_ERROR', error.response?.data?.message || 'Failed to fetch addresses')
      throw error
    } finally {
      commit('SET_ADDRESSES_LOADING', false)
    }
  },
  
  async fetchAddressColumns({ commit }) {
    try {
      const { data } = await addressService.fetchAddressColumns()
      return data
    } catch (error) {
      console.error('Error fetching address columns:', error)
      throw error
    }
  },
  
  async updateAddressColumn({ commit }, columnName) {
    try {
      const { data } = await addressService.updateAddressColumn(columnName)
      return data
    } catch (error) {
      console.error('Error updating address column:', error)
      throw error
    }
  },
  
  async updateAddressColumnOrder({ commit }, columns) {
    try {
      const { data } = await addressService.updateAddressColumnOrder(columns)
      return data
    } catch (error) {
      console.error('Error updating address column order:', error)
      throw error
    }
  },

  async downloadAddressTemplate({ commit }) {
    try {
      const response = await addressService.downloadAddressTemplate()
      // Create a blob URL and trigger download
      const blob = new Blob([response.data], { 
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
      })
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = 'Account-Address-Upload-Template.xlsx'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    } catch (error) {
      console.error('Error downloading address template:', error)
      throw error
    }
  },

  async exportAddresses({ commit }, data) {
    try {
      const response = await addressService.exportAddresses(data)
      return response.data
    } catch (error) {
      console.error('Error exporting addresses:', error)
      throw error
    }
  },

  async importAddresses({ commit }, formData) {
    try {
      const response = await addressService.importAddresses(formData)
      return response.data
    } catch (error) {
      console.error('Error importing addresses:', error)
      throw error
    }
  },

  async deleteAddresses({ commit }, ids) {
    try {
      const response = await addressService.deleteAddresses(ids)
      return response.data
    } catch (error) {
      console.error('Error deleting addresses:', error)
      throw error
    }
  }
}